module.exports = __webpack_public_path__ + "static/modular-banner-3b40860c390b40563eb56bdb358dcd56.svg";